import { InputGroup } from 'react-bootstrap'
import Form from 'react-bootstrap/Form'

const InputModalFaculty = ({ inputText, placeHolder, value, name, type, action, readonly, ...props }) => {
    return (
        <InputGroup className='mb-3'>
            <InputGroup.Text>{inputText}</InputGroup.Text>
            {readonly === 'false' ? (
                <Form.Control
                    placeholder={placeHolder}
                    aria-describedby='basic-addon1'
                    name={name}
                    type={type}
                    value={value}
                    onChange={(e) => action(e)}
                    {...props}
                />
            ) : (
                <Form.Control
                    placeholder={placeHolder}
                    aria-describedby='basic-addon1'
                    name={name}
                    type={type}
                    defaultValue={value}
                    tabIndex={-1}
                    readOnly
                />
            )}
        </InputGroup>
    )
}

export default InputModalFaculty
